import { c as _c } from "react/compiler-runtime";
import { LOCALE } from '@/constants/config';
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { useCancellationTexts } from '@winelidays/wld-tsx-2/hooks';
import { Section } from '@winelidays/wld-tsx-2/modules';
const BookingConditions = t0 => {
    const $ = _c(22);
    const { reducedSectionWidth, innerClassName: t1, cancellation } = t0;
    const innerClassName = t1 === undefined ? "" : t1;
    const translate = useTranslate();
    const { symbol: currencySymbol } = useCurrency();
    let t2;
    if ($[0] !== translate) {
        t2 = translate("booking_conditions_section.title");
        $[0] = translate;
        $[1] = t2;
    }
    else {
        t2 = $[1];
    }
    const title = t2;
    let t3;
    if ($[2] !== translate) {
        t3 = translate("booking_conditions_section.cancellation_conditions.label");
        $[2] = translate;
        $[3] = t3;
    }
    else {
        t3 = $[3];
    }
    const cancellationLabel = t3;
    const t4 = cancellation;
    let t5;
    if ($[4] !== currencySymbol || $[5] !== t4 || $[6] !== translate) {
        t5 = {
            cancellation: t4,
            translate,
            locale: LOCALE,
            currencySymbol
        };
        $[4] = currencySymbol;
        $[5] = t4;
        $[6] = translate;
        $[7] = t5;
    }
    else {
        t5 = $[7];
    }
    const { title: cancellationTitle, description: cancellationDescription } = useCancellationTexts(t5);
    const cancellationText = cancellation.fees?.value ? `${cancellationTitle} ${cancellationDescription}` : cancellationTitle;
    let t6;
    if ($[8] !== title) {
        t6 = <h2 className="text-title mb-6">{title}</h2>;
        $[8] = title;
        $[9] = t6;
    }
    else {
        t6 = $[9];
    }
    let t7;
    if ($[10] !== cancellationLabel) {
        t7 = <span className="text-gray-400">{cancellationLabel} : </span>;
        $[10] = cancellationLabel;
        $[11] = t7;
    }
    else {
        t7 = $[11];
    }
    let t8;
    if ($[12] !== cancellationText || $[13] !== t7) {
        t8 = <p className="text-gray-500 font-semibold">{t7}{cancellationText}</p>;
        $[12] = cancellationText;
        $[13] = t7;
        $[14] = t8;
    }
    else {
        t8 = $[14];
    }
    let t9;
    if ($[15] !== t6 || $[16] !== t8) {
        t9 = <>{t6}{t8}</>;
        $[15] = t6;
        $[16] = t8;
        $[17] = t9;
    }
    else {
        t9 = $[17];
    }
    let t10;
    if ($[18] !== innerClassName || $[19] !== reducedSectionWidth || $[20] !== t9) {
        t10 = <><Section id="booking-conditions" innerClassName={innerClassName} reducedSectionWidth={reducedSectionWidth}>{t9}</Section></>;
        $[18] = innerClassName;
        $[19] = reducedSectionWidth;
        $[20] = t9;
        $[21] = t10;
    }
    else {
        t10 = $[21];
    }
    return t10;
};
export default BookingConditions;
